import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import {AVAILABLE_REACTION_LIST, REACTION_ICON_SIZES} from '../../../modules/comments/reactions/constants';
import ArticleReactionButton from '../article-reaction-button';

import styles from './article-reactions-list.module.css';

const ArticleReactionsList = ({
  currentReactions,
  userReaction,
  onReactionClick,
  variant,
  size
}) => {
  const isMobile = window.Site.targeting.platform === 'smartphone';
  const iconSize = size || isMobile ? REACTION_ICON_SIZES.SMALL : REACTION_ICON_SIZES.MEDIUM;
  const variants = {
    primary: styles.primary,
    secondary: styles.secondary
  };

  if (!currentReactions) {
    return null;
  }
  return (
    <div className={clsx(styles.list, variants[variant])}>
      {
        AVAILABLE_REACTION_LIST.map(reactionType => (
          <ArticleReactionButton
            type={reactionType}
            key={reactionType}
            onClick={() => onReactionClick(reactionType)}
            count={currentReactions?.[reactionType]?.count}
            isActive={userReaction === reactionType}
            size={iconSize}
            variant={variant}
          />
        ))
      }
    </div>
  );
};

ArticleReactionsList.propTypes = {
  currentReactions: PropTypes.object.isRequired,
  userReaction: PropTypes.string.isRequired,
  onReactionClick: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary']),
  size: PropTypes.oneOf([...Object.values(REACTION_ICON_SIZES), null])
};

ArticleReactionsList.defaultProps = {
  variant: 'primary',
  size: null
};

export default ArticleReactionsList;
